export const isDocumentLinkValid = (link) => {
  return /^https?:\/\//i.test(link) || /^ftp:\/\//i.test(link);
};
